import type { getResponseTimeSettingsV2 } from '@/services/getResponseTimeSettingsV2';

/**
 * Formats a response time (in hours) to a human-readable string.
 * Returns the bucket label directly, which already includes the formatted text.
 */
export function formatResponseTimeLabel(
  responseTime: number | undefined,
  buckets: Awaited<ReturnType<typeof getResponseTimeSettingsV2>>
): string {
  if (!responseTime) {
    return '';
  }

  const bucket = buckets.find((b) => responseTime <= b.maxTime);

  if (!bucket) {
    return '';
  }

  return bucket.label;
}
